var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onAdd()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("ChannelThirdPartyPlatform.Add")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: {
            data: _vm.tableData,
            border: "",
            size: "mini",
            height: _vm.minHeight,
            stripe: true,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Account"),
              prop: "account",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.code"),
              prop: "accountCode",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.API"),
              prop: "apiServiceUrl",
              align: "center",
              width: "99",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.app_Key"),
              prop: "appKey",
              align: "center",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.name"),
              prop: "appName",
              align: "center",
              width: "149",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.type"),
              prop: "appType",
              align: "center",
              width: "149",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Authorizable"),
              prop: "authAccount",
              align: "center",
              width: "103",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.address"),
              prop: "authUrl",
              align: "center",
              width: "166",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Number"),
              prop: "bpCode",
              align: "center",
              width: "105",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Callback"),
              prop: "callBackUrl",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.traffic"),
              prop: "certificateFlow",
              align: "center",
              width: "85",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Channel"),
              prop: "channelCode",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Creator"),
              prop: "createdBy",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Creation"),
              prop: "creationDate",
              align: "center",
              width: "140",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Currency"),
              prop: "currency",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Delete"),
              prop: "deleteFlag",
              align: "center",
              width: "104",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.deleteFlag === 0 ? "info" : "success",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            scope.row.deleteFlag === 0
                              ? _vm.$t("ChannelThirdPartyPlatform.Normal")
                              : _vm.$t("ChannelThirdPartyPlatform.Exception")
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Last"),
              prop: "lastUpdateDate",
              align: "center",
              width: "140",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.by"),
              prop: "lastUpdatedBy",
              align: "center",
              width: "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Other"),
              prop: "otherUrl",
              align: "center",
              width: "115",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Development"),
              prop: "platformAddress",
              align: "center",
              width: "164",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Project"),
              prop: "project",
              align: "center",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Remarks"),
              prop: "remark",
              align: "center",
              width: "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Status"),
              prop: "status",
              align: "center",
              width: "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.status === 0 ? "info" : "success",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            scope.row.status === 0
                              ? _vm.$t("ChannelThirdPartyPlatform.Normal")
                              : _vm.$t("ChannelThirdPartyPlatform.Exception")
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.System"),
              prop: "systemFlagCode",
              align: "center",
              width: "86",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelThirdPartyPlatform.Tax"),
              prop: "taxCode",
              align: "center",
              width: "80",
            },
          }),
        ],
        1
      ),
      _c("DataForm", { ref: "DataForm", on: { reFresh: _vm.getData } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }